"use client";

import Link from "next/link";
import { Button } from "@modernatc/ui/button";
import { Callsign } from "@modernatc/ui/callsign";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: ErrorProps) {
  return (
    <main className="mx-auto flex min-h-screen max-w-3xl flex-col items-start justify-center gap-6 px-4 py-24 sm:px-6">
      <Callsign className="text-callsign text-2xl text-[var(--color-critical)]">
        ⚠ MAYDAY
      </Callsign>
      <h1 className="text-balance text-4xl font-semibold tracking-tight text-[var(--color-ink)]">
        Something broke.
      </h1>
      <p className="text-pretty text-lg text-[var(--color-ink-dim)]">
        An unexpected error occurred. We&rsquo;ve logged it and the team
        will look at it shortly. Try the action again, or go home.
      </p>
      {error.digest ? (
        <p className="text-callsign text-xs text-[var(--color-ink-muted)]">
          Reference: {error.digest}
        </p>
      ) : null}
      <div className="flex flex-wrap gap-3">
        <Button onClick={reset} size="lg" variant="primary">
          Try again
        </Button>
        <Button asChild size="lg" variant="secondary">
          <Link href="/">Back to home</Link>
        </Button>
      </div>
    </main>
  );
}
